import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import Tooltip from '@material-ui/core/Tooltip';
import { Chip } from '@material-ui/core';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { AppConfig } from '../../AppConfig';
import { CustomBaseEnityStyles } from '../../styles/CustomStyles';
import { FilterDrawer } from '../../components/FilterDrawer';
import { MultiselectFilterBar } from '../../common/components/MultiselectFilterBar';
// import { SearchBarVenues } from '../../components/SearchBarVenues';
import { vsprintf } from 'sprintf-js';
import { AppHelper } from '../../helpers/AppHelper';
import { SearchBar } from '../../common/components/SearchBar';
import { VenueDetails } from '../../components/VenueDetails';
import { venueCommandsFieldDef, venueStateOptions } from '../../data/data';
import { DynamicFormDialog } from '../../common/components/DynamicFormDialog';
import { VenueAdsPlayer } from '../../components/VenueAdsPlayer';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { Controller } from '../../common/Controller';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { VenueEsperInfo } from '../../components/VenueEsperInfo';
import { VenueSummary } from '../../components/VenueSummary';
import { DeviceNetworkInfoDialog } from '../../components/DeviceNetworkInfoDialog';

export class VenuesWithSearch extends BaseEntityPage {
  static ViewState = Object.freeze({
    INIT: 1,
    PROGRESS: 2,
    ERROR: 3,
    SUCCESS: 4
  })

  constructor(props) {
    super(props)
    this.pageKey = 'Venues'
    this.pageTitle = Helper.getString('venues')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.sitesById = {}
    this.brandNamesById = {}
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.defaultState = '_ALL'
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'devicesearchdb'],
        queryParams: { facets: [], pb: 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefVenueInfo,fieldDefDeviceLogo,fieldDefNetworkInfo', state: this.defaultState } },
      { method: 'GET', paths: ['playlists'], queryParams: { iType: 'DEFAULT' } },
      //{ method: 'GET', paths: ['miscs', 'orgfastlistall'], queryParams: { state: 'LIVE' } },
      { method: 'GET', paths: ['miscs', 'orgsearch'], queryParams: { shallow: true, state: 'LIVE', limit: AppConfig.ORG_SEARCH_LIMIT } },
      //{ method: 'GET', paths: ['miscs', 'campaigns'], queryParams: { groupId: 'PRODUCT', state: 'LIVE', pb: 'fieldDef', limit: 1500 } },
      { method: 'GET', paths: ['miscs', 'campaigns'], queryParams: { groupId: 'PRODUCT', pb: 'fieldDef', state: 'LIVE', shallow: true, limit: 10000} },
      { method: 'GET', paths: ['devicetags'], queryParams: { groupId: 'PRODUCT', pb: 'fieldDef', limit: 1000 } },
      { method: 'GET', paths: ['venuegroups'], queryParams: { groupId: 'PRODUCT' } },
      { method: 'GET', paths: ['miscs', 'layouts'], queryParams: { orgId: 'PRODUCT', state: 'LIVE', layoutType: 'SL' } },
      { method: 'GET', paths: ['items'], queryParams: { groupId: 'brandname' + this.orgId, pb: 'fieldDef' } },
      { method: 'GET', paths: ['items'], queryParams: { groupId: 'restrictiontag' + this.orgId, pb: 'fieldDef', limit: 1000 } },
    ]
    this.cellWidths = {
      Index: Styles.indexCell,
      Venue: Styles.venueCell,
      Info: Styles.infoCell,
      Status: Styles.statusCell,
      actions: Styles.actionsCell
    }
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Venue: (current) => {
        const site = current.orgId && this.sitesById[current.orgId]
        return (
          <div>
            <VenueSummary
              item={current}
              site={site}
              compact
              showspd
              deviceCodeNode={<Link target='_blank' to={'/admin/screens/' + current.id} key={current.id + '-org'}>{current.deviceCode}</Link>}
            />
          </div>
        )
      },
      Info: (current) => {
        const hasLatestFeed = current.latestDeviceFeed && current.latestDeviceFeed.currentTs
        const screenLayoutCount = current.screenLayouts && current.screenLayouts.length || 0
        return (
          <div className={css(Styles.infoColumn)}>
            {hasLatestFeed &&
              <div>
                <span className={css(Styles.spanValue, Styles.line2)}>
                  {AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs)}
                </span>
              </div>
            }
            {hasLatestFeed && !AppHelper.isNonApkDevice(current) &&
              <div>
                <span className={css(Styles.spanValue, Styles.line2)}>
                  App #{current.latestDeviceFeed.versionCode || 'UNKNOWN'} | Model #{current.latestDeviceFeed.model || 'UNKNOWN'}
                </span>
              </div>
            }
            {(current.info && current.info.vistarId) &&
              <div>
                <span className={css(Styles.spanValue, Styles.line2)}>vistarId: {current.info.vistarId}</span>
              </div>
            }
            <div>
              <span className={css(Styles.spanValue, Styles.line2)}>
                {/* Orientation: {current._ORIENTATION || 'UNKNOWN'} | Screen Groups: {(current.venueGroups || []).length} | Screen Layouts: {screenLayoutCount} */}
                Orientation: {current._ORIENTATION || 'UNKNOWN'} | Screen Layouts: {screenLayoutCount}
              </span>
            </div>
            <div>
              <span className={css(Styles.spanValue, Styles.line2)}>
                Site: {current.orgId ? 'YES' : 'NO'} | Partner: {current.partnerOrgId ? 'YES' : 'NO'} | PA: {current.paOrgId ? 'YES' : 'NO'} | FA: {current.faOrgId ? 'YES' : 'NO'} | Image: {current.imageName ? 'YES' : 'NO'}
              </span>
            </div>
            <div>
              <span className={css(Styles.spanValue, Styles.line2)}>
                Display Campaigns: {(current.campaigns || []).length} | Audio Campaigns: {(current.playlists || []).length} | Tags: {(current.tagsBo || []).length}
              </span>
            </div>
            <div>
              {current.tagsBo &&
                <div className={css(Styles.tagHolder)}>
                  {AppHelper.getTagChips(current.tagsBo, this.state.tags).map((x, i) =>
                    <Chip key={'chip_' + i} label={x} size='small' className={css(Styles.tagChip)} />
                  )}
                </div>
              }
            </div>
          </div>
        )
      },
      Status: (current) => {
        return (
          <Fragment>
            <div className={css(Styles.statusHolder)}>
              <div className={css(Styles.displayInRow)}>
                <span>
                  {
                    (current.latestDeviceFeed && current.latestDeviceFeed.currentTs) ?
                      AppHelper.getVenueStatus(Helper.currentTs() - current.latestDeviceFeed.currentTs)
                      : AppHelper.offlineStatus()
                  }
                </span>
                <span>{AppUiHelper.getVenueSignalStatus(current)}</span>
              </div>
              {AppHelper.getHdmiInfo(current)}
            </div>
          </Fragment>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
    this.noTableHead = true
    this.emptyText = Helper.getString('noResults')
    this.headerActions = [
      {
        label: Helper.getString('filters'),
        icon: 'filter_list',
        onClick: () => this.setDrawer(),
        type: 'icon-mobile'
      },
      // {
      //   icon: 'add',
      //   label: 'Add Venue',
      //   onClick: () => this.openModalForAdd()
      // },
      {
        icon: 'add',
        label: 'New Screen',
        onClick: () => this.openModalForNewVenue(),
        type: 'icon-mobile'
      }
    ]
    this.logoFormDef = null
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 100
  }

  onFetchSuccess(results, options) {
    console.log('onFetchSuccess:', results)
    const { fetchNext } = options || {}
    const mainResult = results[0]
    if(mainResult && mainResult.fieldDefDeviceLogo) {
      this.logoFormDef = mainResult.fieldDefDeviceLogo
      this.logoFormDef.title = Helper.getString('screenSettings')
    }

    if(!fetchNext) {
      if(mainResult.fieldDefInstallation) {
        this.fieldDefInstallation = mainResult.fieldDefInstallation
        this.fieldDefInstallation.dialogHeading = 'Registration'
      }
      this.fieldDef = mainResult.fieldDef
      this.fieldDefVenueGen = mainResult.fieldDefVenueGen
      this.fieldDefVenueInfo = mainResult.fieldDefVenueInfo
      this.fieldDefNetworkInfo = mainResult.fieldDefNetworkInfo
      this.fieldDef.steps[0].fields = this.fieldDef.steps[0].fields.filter(f => {
        return !Helper.inArray([
          'audioAdId', 'audioAdIds', 'audioAdPartnerIds', 'imageAdId', 'imageAdIds', 'imageAdPartnerIds',
          'campaignsPartner', 'tagsPartner', 'venueGroups'
          // 'title'
        ], f.key) // to be only in org devices
      })
      this.formDefinition = this.fieldDef
      const sites = []
      const partners = []
      const pas = []
      const fas = []
      results[2].items.forEach(org => {
        if (org.groupId === 'PARTNER') {
          partners.push(org)
        } else if(org.groupId === 'SITE') {
          sites.push(org)
        } else if(org.groupId === 'PA') {
          pas.push(org)
        } else if(org.groupId === 'FA') {
          fas.push(org)
        }
      });
      this.sitesById = sites.reduce((acc, site) => {
        acc[site.id] = site
        return acc
      }, {})
      this.brandNamesById = (results[7].items || []).reduce((acc, item) => {
        acc[item.id] = item.title
        return acc
      }, {})
      UiHelper.populateOptions(this.fieldDef, results[1], 'playlists')
      UiHelper.populateOptions(this.fieldDef, results[3], 'campaigns')
      UiHelper.populateOptions(this.fieldDef, results[4], 'tagsBo')
      UiHelper.populateOptions(this.fieldDef, results[8], 'restrictionTagsBo')
      UiHelper.populateOptions(this.fieldDefVenueInfo, results[7], 'brandName')
      this.fieldDef.steps[0].fields.map((x) => {
        if (x.type === 'check_box' && x.key === 'tagsBo') {
          x.addOptions = true
        }
        return x
      })
      UiHelper.populateOptions(this.fieldDef, results[5], 'venueGroups')
      UiHelper.populateOptions(this.fieldDef, { items: sites }, 'orgId')
      UiHelper.populateOptions(this.fieldDef, { items: partners }, 'partnerOrgId')
      UiHelper.populateOptions(this.fieldDef, { items: pas }, 'paOrgId')
      UiHelper.populateOptions(this.fieldDef, { items: fas }, 'faOrgId')
      UiHelper.populateOptions(this.logoFormDef, { items: results[6].items || [] }, 'screenLayouts')
    }

    this.handleNextpage(results[0])
    this._changePaginationLimit()
    console.log(this.toFetch[0])
    const normalizedItems = (mainResult.items || []).map(item => {
      const brandNameId = item.info && item.info.brandName
      if (!brandNameId) return item
      return {
        ...item,
        brandName: this.brandNamesById[brandNameId] || brandNameId
      }
    })
    const items = fetchNext ? this.state.items.concat(normalizedItems) : normalizedItems
    if (!fetchNext) {
      this.setState({
        item: results[0],
        items: AppHelper.processVenueItems(items),
        facets: mainResult && mainResult.stats && mainResult.stats.facets || [],
        facetFetchState: VenuesWithSearch.ViewState.SUCCESS,
        stateFilterValue: this.defaultState,
        slLayouts: results[6].items || [],
        tags: results[4]
      })
    } else {
      this.setState({
        item: results[0],
        items: AppHelper.processVenueItems(items),
      })
    }
  }

  openModalForInstallationEdit(current) {
    console.log('openModalForInstallationEdit:', current);
    this.formDefinition = this.fieldDefInstallation
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.onEdit(current);
    this.setState({
      modalOpen: true
    });
  }

  openModalForInfoEdit(current) {
    console.log('openModalForInfoEdit:', current);
    this.formDefinition = this.fieldDefVenueInfo
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current.info || {})
    this.onInfoEdit(current);
    this.setState({
      modalOpen: true
    })
  }

  openModalForNewVenue() {
    this.formDefinition = this.fieldDefVenueGen
    this.formDefinition.formType = 'add'
    this.onAdd();
    this.setState({
      modalOpen: true
    })
  }

  setDrawer() {
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen })
  }

  onClear() {
    if(this.searchBarComponent) this.searchBarComponent.setState({searchText:''})
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
      selectedFilters: {},
      selectedTagsId: [],
      searchText: '',
      inProcessOnList: true,
      inProcessSearch: false,
      inProcessTagSearch: false
    }, () => this.onFacetsFetch())
  }

  onList() {
    if(this.searchBarComponent) this.searchBarComponent.setState({searchText:''})
    this.setState({
      selectedFilters: {},
      selectedTagsId: [],
      searchText: '',
      inProcessOnList: true,
      inProcessSearch: false,
      inProcessTagSearch: false,
      stateFilterValue: this.defaultState
    }, () => this.onFacetsFetch())
  }

  getQueryParams() {
    const params = this.state.selectedFilters || {}
    const facets = []
    let item = {}
    const paramsSpec = params
    for (const k in paramsSpec) {
      if (!Array.isArray(paramsSpec[k])) {
        params[k] = [paramsSpec[k]]
      }
    }

    for (const f in params) {
      const valuesArr = []
      if (params[f] && params[f].length > 0) {
        for (const k of params[f]) {
          valuesArr.push(k.value)
        }
      }
      item = { key: f, values: valuesArr }
      facets.push(item)
    }

    const queryParams = {
      facets: JSON.stringify(facets),
    }

    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.selectedTagsId && this.state.selectedTagsId.length > 0) {
      queryParams.tagsBo = this.state.selectedTagsId.map(x => x.key).join(',')
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }
    this.toFetch[0] = { method: 'GET', paths: ['miscs', 'devicesearchdb'], queryParams: { ...queryParams, pb: 'fieldDef,fieldDefInstallation,fieldDefVenueGen,fieldDefVenueInfo,fieldDefNetworkInfo' } }
    this.handleNextpage(this.state.item)
    this._changePaginationLimit()
    console.log(this.toFetch[0])
    return queryParams
  }

  onFacetsFetch() {
    this.setState({
      facetFetchState: VenuesWithSearch.ViewState.PROGRESS
    })

    ApiHelper.call(
      {
        method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'devicesearchdb'], this.getQueryParams()),
      },
      function (err, data) {
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            facetFetchState: VenuesWithSearch.ViewState.ERROR,
            errMsg: Helper.getErrorMsg(err),
            item: {},
            items: [],
            nextPage: '',
            inProcessSearch: false,
            inProcessTagSearch: false,
            inProcessOnList: false
          })
          return
        }
        else {
          this.emptyText = (
            <span className={css(Styles.emptyTextHolder)}>
              <span>{Helper.getString('noVenue')}</span>
            </span>
          )
          this.handleNextpage(data)
          this._changePaginationLimit()
          this.setState({
            facetFetchState: VenuesWithSearch.ViewState.SUCCESS,
            successMsg: '',
            facets: data.stats.facets,
            item: data,
            items: AppHelper.processVenueItems(data.items),
            errMsg: null,
            inProcessSearch: false,
            inProcessTagSearch: false,
            inProcessOnList: false
          })
        }
      }.bind(this));
  }

  handleSelection = (value, id) => {
    const fParams = { ...this.state.selectedFilters }
    if (value && value.length > 0) {
      fParams[id] = value
    } else {
      delete fParams[id]
    }
    this.setState({
      selectedFilters: { ...fParams },
      inProcessSearch: false,
      inProcessTagSearch: false,
      inProcessOnList: false
    }, () => this.onFacetsFetch())
  }

  onSearch = (searchText) => {
    this.setState({
      searchText: searchText,
      selectedTagsId: [],
      inProcessSearch: true,
      inProcessTagSearch: false,
      inProcessOnList: false
    }, () => { this.onFacetsFetch() })
  }

  onTagFilter = (selectedTagsId) => {
    if(this.searchBarComponent) this.searchBarComponent.setState({searchText:''})
    this.setState({
      searchText: '',
      selectedTagsId: selectedTagsId,
      stateFilterValue: this.defaultState,
      inProcessSearch: false,
      inProcessTagSearch: true,
      inProcessOnList: false
    }, () => this.onFacetsFetch())
  }

  async onFormFieldOptionAdd(options) {
    const { formField, value, formId } = options
    if (this.formDefinition && this.formDefinition.formId === formId) {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['devicetags']),
        jsonBody: { groupId: 'PRODUCT', title: value }
      })
      const updatedResult = await ApiHelper.callAwait({
        method: 'GET',
        paths: ['devicetags'],
        queryParams: { groupId: 'PRODUCT', pb: 'fieldDef' }
      })
      this.formDefinition.steps[0].fields.map(x => {
        if (x.key === formField.key) {
          UiHelper.populateOptions(this.formDefinition, updatedResult, formField.key)
        }
        return x
      })
      this.setState({ tags: updatedResult })
      return updatedResult || {}
    }
  }

  renderAppliedFilters = () => {
    if (!this.state.selectedFilters) return ''
    return (
      <div className={css(Styles.appliedFiltersContainer)}>
        {
          Object.keys(this.state.selectedFilters).map((key) => {
            return this.state.selectedFilters[key].map((item, index) => {
              return <div className={css(Styles.filterTile)}>{key}: {item.value}</div>
            })
          })
        }
      </div>
    )
  }

  renderAboveTable() {
    let inProcess = false
    if (this.state.facetFetchState === VenuesWithSearch.ViewState.PROGRESS) {
      inProcess = true
    }
    return (
      <Fragment>
        {!AppConfig.FEATURES_OFF.includes('DISPLAY_ADS_PLAYER') && this.state.showAdsPlayer &&
          <VenueAdsPlayer
            isOpen={this.state.showAdsPlayer || false}
            inProcess={this.state.showAdsPlayerLoading || false}
            title={this.state.venueAdsPlayerTitle || Helper.getString('adsPlayButtonTitle')}
            onClosed={() => { this.onCloseAdsPlayer() }}
            ads={this.state.playableAdsList || []}
            orientation={this.state.playerOrientation || ''}
            showError={this.state.adsPlayerError || null}
          ></VenueAdsPlayer>
        }
        <DynamicFormDialog
          customSubmit={this.sendCommandCustomDialogHandle}
          formDefinition={venueCommandsFieldDef.fieldDef}
          isOpen={this.state.showCommandDialog || false} // Added false for fixing console warning.
          onClosed={() => this.setState({showCommandDialog: false})}
        >
        </DynamicFormDialog>
        <VenueDetails
          isOpen={this.state.showInfo}
          title={(this.state.device && this.state.device.title) ? this.state.device.title : Helper.getString('venueInfo')}
          onClosed={() => this.setState({ showInfo: false })}
          fullWidth={true}
          selectedDevice={this.state.device}
        />
        <VenueEsperInfo
          isOpen={this.state.esperShowInfo}
          title={(this.state.device && this.state.device.title) ? this.state.device.title : Helper.getString('liveLocation')}
          onClosed={() => this.setState({ esperShowInfo: false })}
          fullWidth={false}
          selectedDevice={this.state.device}
        />
        <DeviceNetworkInfoDialog
          current={this.state.networkInfoDevice}
          fieldDefNetworkInfo={this.fieldDefNetworkInfo}
          isOpen={this.state.showNetworkInfoDialog || false}
          onClosed={() => this.setState({ showNetworkInfoDialog: false, networkInfoDevice: null })}
          onCompleteAction={() => {
            this.setState({ showNetworkInfoDialog: false, networkInfoDevice: null })
            this.fetchItems()
          }}
        />
        <div className={css(Styles.searchContainer)}>
          {/* <SearchBarVenues
          placeholder={'Search'}
          inProcess={inProcess}
          onSearch={this.onSearch.bind(this)}
          onSearchtextChange={(searchText) => this.setState({ searchText })}
          searchText={this.state.searchText}>
        </SearchBarVenues> */}
          <SearchBar
            ref={(child) => (this.searchBarComponent = child)}
            hint={'Search'}
            inProcessSearch={this.state.inProcessSearch || false}
            inProcessOnList={this.state.inProcessOnList || false}
            // onList={this.onList.bind(this)}
            onSearch={this.onSearch.bind(this)}
            searchText={this.state.searchText}
            onSinglePickerFilter={this.onStateFilter.bind(this)}
            singleSelectPicker={
              {
                options: venueStateOptions,
                defaultValue: this.state.stateFilterValue,
                // title: 'Select State'
              }
            }
            showRecentButtonText={'Reset Filter'}>
          </SearchBar>
          <MultiselectFilterBar
            value={this.state.selectedTagsId || []}
            onList={this.onList.bind(this)}
            onSearch={this.onTagFilter}
            inProcessSearch={this.state.inProcessTagSearch || false}
            inProcessOnList={this.state.inProcessOnList || false}
            items={this.state.tags && this.state.tags.items && this.state.tags.items.map(x => {
              return { key: x.id, title: x.title }
            })}
            placeholder={Helper.getString('selectTags')}
            resetFilterText={'Reset Filter'}
          />
          {this.renderAppliedFilters()}
          {this.state.facets &&
            <FilterDrawer
              open={this.state.isDrawerOpen || false}
              onClose={() => this.setDrawer()}
              onOpen={() => this.setDrawer()}
              inProcess={inProcess}
              onClear={() => this.onClear()}
              errMsg={this.state.errMsg}
              selectedFilters={this.state.selectedFilters}
              handleSelection={this.handleSelection}
              item={this.state.facets}
            />
          }
        </div>
        {this.renderAddLogoModal()}
      </Fragment>
    )
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue:selectedState
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['devices']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData:{},
      apiEndPoint: ApiHelper.makeUrlPath(['devices', current.id]),
    });
  }

  onInfoEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'mergeUpdateInfo'
      },
      apiEndPoint: ApiHelper.makeUrlPath(['devices', current.id]),
    });
  }

  onActions(current) {
    const actions = []
    // actions.push(
    //   <Tooltip title={Helper.getString('networkInfo')} placement='top-start' key={current.id + 'NetworkInfo'}>
    //     <span className={css(AppStyles.entityTableLinkIcon)}>
    //       <i className='material-icons-outlined' onClick={() =>
    //         this.setState({ showNetworkInfoDialog: true, networkInfoDevice: current })
    //       }>router</i>
    //     </span>
    //   </Tooltip>
    // )
    actions.push(
      <Tooltip title='Registration' placement='top-start' key={current.id + 'Reg'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() =>
            this.openModalForInstallationEdit.bind(this)(current)
          }>personal_video</i>
        </span>
      </Tooltip>
    )
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(
      <Tooltip title='Edit Info' placement='top-start' key={current.id + 'Info'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() =>
            this.openModalForInfoEdit.bind(this)(current)
          }>settings</i>
        </span>
      </Tooltip>
    )
    if(current.installationId) {
      if(!AppConfig.FEATURES_OFF.includes('DEVICE_INFO')) {  actions.push(this.infoButton(current)) }
      // actions.push(this.esperInfoButton(current))
    }
    // if (current.installationId && !AppConfig.FEATURES_OFF.includes('SEND_COMMAND_TO_SCREEN')) {
    //   actions.push(this.sendCommandButton(current))
    // }
    if (current.installationId && !AppConfig.FEATURES_OFF.includes('DISPLAY_ADS_PLAYER')) {
      actions.push(this.adPlayerButton(current))
    }
    // actions.push(this.addLogoButton(current))
    // actions.push(UiHelper.addActionButtonByRole(actions, this.deviceTasksButton(current)))
    return actions
  }


  deviceTasksButton(current) {
    return (
      <Link target='_blank' to={'/admin/screens/' + current.deviceCode + '/tasks'}
        key={current.id + '-org'}>
        <Tooltip title='Device Tasks' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>directions_run</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  addLogoButton(current) {
    return (
      <Tooltip title={Helper.getString('screenSettings')} placement='top-start' key={'addLogoButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.showAddLogoDialog(current)}>motion_photos_on</i>
        </span>
      </Tooltip>
    )
  }

  showAddLogoDialog(current) {
    const logoFormDef = this.logoFormDef
    this.currentSelectedVenue = current
    Helper.populateFormDefinitionValues(logoFormDef, current)
    this.setState({
      showAddLogoModal: true,
      fieldDefDeviceLogo: logoFormDef
    })
  }

  closeAddLogoDialog = () => {
    this.setState({
      showAddLogoModal: false
    })
  }

  renderAddLogoModal() {
    if (!this.state.fieldDefDeviceLogo) return
    return (
      <DynamicFormDialog
        apiMethod={'PUT'}
        apiEndPoint={ApiHelper.makeUrlPath(['devices', this.currentSelectedVenue && this.currentSelectedVenue.id])}
        formDefinition={this.state.fieldDefDeviceLogo ? { ...this.state.fieldDefDeviceLogo, formType: 'edit' } : {}}
        isOpen={this.state.showAddLogoModal || false}
        onClosed={this.closeAddLogoDialog}
        onCompleteAction={() => {
          this.closeAddLogoDialog()
          this.fetchItems()
        }} />
    )
  }

  onCloseAdsPlayer() {
    this.setState({
      showAdsPlayer: false,
      showAdsPlayerLoading: null,
      venueAdsPlayerTitle: '',
      adsPlayerError: null,
      playableAdsList: []
    })
  }

  adPlayerButton(current) {
    return (
      <Tooltip title={Helper.getString('adsPlayButtonTitle')} placement='top-start' key={'adsPlayButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.getAdsOfVenue(current) }>play_circle</i>
        </span>
      </Tooltip>
    )
  }

  getAdsOfVenue(current) {
    if (current.installationId) {
      this.setState({
        showAdsPlayer: true,
        showAdsPlayerLoading: true,
        venueAdsPlayerTitle: current.title,
        adsPlayerError: null
      })
      // Job API Call
      ApiHelper.call({
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['ivenues'], { installationId: current.installationId, hb: 'NO' })
      }, (err, result) => {
        if (err) {
          const errorMessage = Helper.getErrorMsg(err)
          console.log(errorMessage)
          this.setState({
            adsPlayerError: errorMessage,
            showAdsPlayerLoading: false,
            playableAdsList: [],
            playerOrientation: ''
          })
          return
        }
        const processAds = AppHelper.processAdsForVenuePlayer(result)
        this.setState({ showAdsPlayerLoading: false, playableAdsList: processAds, playerOrientation:result.orientation })
      })
    }
  }

  esperInfoButton(current) {
    return (
      <Tooltip title={Helper.getString('liveLocation')} placement='top-start' key={'esperInfoBtn'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.setState({ esperShowInfo: true, device: current })}>fmd_good</i>
          {/* <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => this.setState({ showInfo: true, device: current }) }/> */}

        </span>
      </Tooltip>
    )
  }

  infoButton(current) {
    return (
      <Tooltip title='Info' placement='top-start' key={'infoBtn'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          {/* <i className='material-icons-outlined' onClick={() => this.setState({ showInfo: true, device: current })}>info</i> */}
          <img className={css(Styles.actionIconImage)} src={require('../../assets/icons/info-circle.svg')} onClick={() => this.setState({ showInfo: true, device: current }) }/>

        </span>
      </Tooltip>
    )
  }

  sendCommandButton(current) {
    return (
      <Tooltip title={Helper.getString('sendCommandTitle')} placement='top-start' key={'commandButton'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.setState({ showCommandDialog: true, device: current }) }>developer_mode</i>
        </span>
      </Tooltip>
    )
  }

  sendCommandCustomDialogHandle = async (data) =>{
    const {formData, caller} = data
    const payload = {
      venueCodes:this.state.device.deviceCode,
      command:formData.command
    }
    // Job API Call
    ApiHelper.call({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath(['miscs', 'bg-push']),
      jsonBody: payload,
    }, (err, result) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
      this.setState({showCommandDialog: false})
    })
  }

  onMenuItems = (current) => {
    const actions = []
    actions.push(UiHelper.actionLinkButton({
      key: `${current.id}-details-history`,
      title: 'Details & Change History',
      link: '/admin/screens/' + current.id,
      icon: 'history'
    }))
    const menuItems = [
      {
        current: current,
        key: current.id + 'NetworkInfo',
        action: () => {
          this.setState({ showNetworkInfoDialog: true, networkInfoDevice: current })
        },
        title: Helper.getString('networkInfo'),
        icon: 'router',
      },
    ]
    menuItems.map(item => {
      actions.push(UiHelper.actionButton(item))
    })
    if (current.installationId) {
      actions.push(UiHelper.actionButton({
        current,
        key: `${current.id}-live-location`,
        action: () => this.setState({ esperShowInfo: true, device: current }),
        title: Helper.getString('liveLocation'),
        icon: 'fmd_good',
      }))
    }
    actions.push(UiHelper.actionButton({
      current,
      key: `${current.id}-screen-settings`,
      action: () => this.showAddLogoDialog(current),
      title: Helper.getString('screenSettings'),
      icon: 'motion_photos_on',
    }))
    UiHelper.addActionButtonByRole(actions, UiHelper.actionLinkButton({
      key: `${current.id}-device-tasks`,
      title: 'Device Task',
      link: '/admin/screens/' + current.deviceCode + '/tasks',
      icon: 'directions_run'
    }))
    actions.push(UiHelper.actionLinkButton({
      title: 'Screen Playback History',
      link: '/admin/screen-playback-history?screen=' + current.deviceCode,
      icon: 'video_library'
    }))
    actions.push(UiHelper.actionLinkButton({
      title: Helper.getString('screenHealthSummary'),
      link: '/admin/screen-health-summary?screen=' + encodeURIComponent(current.deviceCode || ''),
      icon: 'monitor_heart'
    }))
    actions.push(UiHelper.actionLinkButton({
      title: 'Screen Fill Rate',
      link: '/admin/screen-fill-rate?screen=' + encodeURIComponent(current.deviceCode || ''),
      icon: 'stacked_bar_chart'
    }))
    if (
      (current.latestDeviceFeed &&
      current.latestDeviceFeed.versionCode >= 188 &&
      current.info &&
      current.info.configtags &&
      Array.isArray(current.info.configtags) &&
      current.info.configtags.includes('DAYPARTING') || AppConfig.DAYPARTING_SCREENS.includes(current.deviceCode))
    ) {
      actions.push(UiHelper.actionLinkButton({
        title: 'Dayparting Schedule',
        link: '/admin/screens/' + current.id + '/dayparting-schedule',
        icon: 'schedule'
      }))
    }
    return actions
  }
}


const Styles = (AppConfig.CUSTOM_STYLE) ? CustomBaseEnityStyles : StyleSheet.create({
  actionIconImage:{
    width: 20,
    height: 20
  },
  entityContainer: {
    marginTop: AppTheme.headerbarHeight,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    backgroundColor: AppTheme.primaryBg,
    marginLeft: 60,
    marginRight: 60,
    maxWidth: AppTheme.viewPort,
    '@media (max-width: 767px)': {
      marginLeft: 10,
      marginRight: 10,
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  breadCrumbsContainer: {
    alignItems: 'flex-start',
    paddingBottom: 0
  },
  header: {
    marginBottom: 30
  },
  spanValue: {
  },
  spanValueTitle: {
    wordBreak: 'break-all'
  },
  storeNameText:{
    fontWeight: 'bolder',
    fontSize: '16px',
    color: '#121212'
  },
  tagHolder:{
    maxWidth:400,
    marginTop: 4
  },
  tagChip:{
    marginRight:6,
    marginBottom:6,
    maxWidth: 300,
    background:'rgba(87, 87, 87, 0.1)',
    borderRadius:17,
    color: 'rgba(87, 87, 87, 1)',
    fontSize:14,
    padding: '16px 4px'
  },
  line2: {
    fontSize: 12
  },
  infoColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 260
  },
  img: {
    height: 30
  },
  appliedFiltersContainer: {
    display: 'flex',
    gap: 15,
    marginBottom: 15
  },
  filterTile: {
    backgroundColor: '#FFFFFF',
    padding: 10,
    borderRadius: 6
  },
  searchContainer: {
    display: 'flex',
    flex: 1,
    // flexDirection: 'column',
    flexDirection: 'row',
    gap: 10
  },
  circleFill:{
    width: 18,
    height: 18,
    borderRadius: '50%',
  },
  emptyTextHolder:{
    display:'grid'
  },
  emptyImage:{
    maxHeight: 120,
    padding:25
  },
  statusHolder:{
    display: 'flex',
    gap: 5,
    flexDirection: 'column',
    minWidth:130
  },
  indexCell: {
    width: 44
  },
  venueCell: {
    width: '26%',
    minWidth: 220,
    maxWidth: 320,
    verticalAlign: 'top'
  },
  infoCell: {
    width: '34%',
    minWidth: 280,
    verticalAlign: 'top'
  },
  statusCell: {
    width: '15%',
    minWidth: 150,
    verticalAlign: 'top'
  },
  actionsCell: {
    width: 140,
    whiteSpace: 'nowrap'
  },
  displayInRow: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '5px'
  },
  infoLinkStyle: {
    color: AppTheme.primaryColor,
    fontWeight: 'bolder'
  },
  link: {
    textDecoration: 'none',
    color: 'black'
  }
})



// WEBPACK FOOTER //
// ./src/screens/admin/VenuesWithSearch.js